require('theia-sticky-sidebar/dist/ResizeSensor');
require('theia-sticky-sidebar/dist/theia-sticky-sidebar');

$(document).ready(function() {
  $(".sticky-sidebar").theiaStickySidebar({
    additionalMarginTop: '40px'
  });
});
